import React, { useContext } from 'react';
import { APPEARANCES, Heading } from '../../../../PageElements/Heading';
import { getName } from '../../../../../../utils/treeVisitors/helpers';
import { NestedTable } from '../../../NestedTable';
import { Text } from '../../../../PageElements/Text';
import style from '../JSOperationView.scss';
import { JSReturnType } from './JSReturnType';
import { getParamWithRequiredField } from '../../utils';
import { getNodeByLink } from '../../../../../../Store/Utils/treeUtils';
import { StoreContext } from '../../../../../appContext/StoreProvider';
import { isVeloSite } from '../../../../../../utils';

export const JSParamTable = ({ operation, path, prefix, JSLayoutType }) => {
  const { store } = useContext(StoreContext);
  const parentNode = getNodeByLink(store.docsTree, operation.parentRef);
  const isAutoVeloDocs = !!(
    isVeloSite(store.viewer.category) && parentNode?.data?.clientId
  );

  const paramsWithRequiredFields = operation.params.map((param) => {
    const paramWithRequiredField = getParamWithRequiredField({
      param,
      operationRequiredFields: operation.requiredFields,
      shouldAddOptionalAnnotation: isAutoVeloDocs,
    });
    return paramWithRequiredField;
  });

  return (
    <React.Fragment>
      <Heading
        appearance={APPEARANCES.H3}
        dataHook="js-param-table-heading"
      >{`${getName(operation)} Parameters`}</Heading>
      {paramsWithRequiredFields.length > 0 ? (
        <NestedTable
          tableDepth={0}
          params={paramsWithRequiredFields}
          path={path}
          prefix={prefix}
          oneOfGroups={operation.extra?.oneOfGroups}
          isAutoVeloDocs={isAutoVeloDocs}
          isRequest={true}
          JSLayoutType={JSLayoutType}
        />
      ) : (
        <Text dataHook="no-parameters-text">
          This function does not take any parameters.
        </Text>
      )}
      <div className={style.returnTypeContainer}>
        <JSReturnType
          ret={operation.ret}
          prefix={prefix}
          name={getName(operation)}
          JSLayoutType={JSLayoutType}
        />
      </div>
    </React.Fragment>
  );
};
